import { render, staticRenderFns } from "./SmallArrow.svg.vue?vue&type=template&id=0ac67bc2"
import script from "./SmallArrow.svg.vue?vue&type=script&lang=ts"
export * from "./SmallArrow.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ac67bc2')) {
      api.createRecord('0ac67bc2', component.options)
    } else {
      api.reload('0ac67bc2', component.options)
    }
    module.hot.accept("./SmallArrow.svg.vue?vue&type=template&id=0ac67bc2", function () {
      api.rerender('0ac67bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/SmallArrow.svg.vue"
export default component.exports